module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAIAAAD9b0jDAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAEdJREFUeNpi/P//PwO1ARMDDcCooaOGjho66A1lwSVx8eH3lBkPPv/4h0czLwfTnAwFfXlOeriUcbToGzV01NBRQ6kFAAIMAE5pDzNTg339AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/shipIcons/maptool/ZOOMIN_V.png
// module id = OdyK
// module chunks = 18